/* Cellmula Skincare — Shopify theme helpers
   Cart (Shopify AJAX API), Wishlist (localStorage), Quick View, Search */

(function() {
  'use strict';

  // ========== UTILITIES ==========
  function formatMoney(cents) {
    if (typeof cents !== 'number') cents = parseInt(cents) || 0;
    return '$' + (cents / 100).toLocaleString('es-MX', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0
    });
  }

  function escapeHtml(str) {
    var d = document.createElement('div');
    d.textContent = str || '';
    return d.innerHTML;
  }

  // ========== WISHLIST (localStorage) ==========
  function getWishlist() {
    try { return JSON.parse(localStorage.getItem('cellmula_wishlist')) || []; }
    catch(e) { return []; }
  }
  function saveWishlist(list) {
    try { localStorage.setItem('cellmula_wishlist', JSON.stringify(list)); } catch(e) {}
  }
  function getWishlistData() {
    try { return JSON.parse(localStorage.getItem('cellmula_wishlist_data')) || {}; }
    catch(e) { return {}; }
  }
  function saveWishlistData(data) {
    try { localStorage.setItem('cellmula_wishlist_data', JSON.stringify(data)); } catch(e) {}
  }

  function toggleWishlist(handle, info) {
    var list = getWishlist();
    var data = getWishlistData();
    var idx = list.indexOf(handle);
    if (idx > -1) {
      list.splice(idx, 1);
      delete data[handle];
    } else {
      list.push(handle);
      if (info) data[handle] = info;
    }
    saveWishlist(list);
    saveWishlistData(data);
    updateWishlistBadge();
    return idx === -1;
  }

  function isInWishlist(handle) {
    return getWishlist().indexOf(handle) > -1;
  }

  function removeFromWishlist(handle) {
    var list = getWishlist().filter(function(h) { return h !== handle; });
    var data = getWishlistData();
    delete data[handle];
    saveWishlist(list);
    saveWishlistData(data);
    updateWishlistBadge();
  }

  // ========== BADGES ==========
  function updateCartBadge(count) {
    document.querySelectorAll('.cart-badge').forEach(function(badge) {
      if (count > 0) {
        badge.textContent = count;
        badge.style.display = 'flex';
      } else {
        badge.style.display = 'none';
      }
    });
  }

  function updateWishlistBadge() {
    var count = getWishlist().length;
    document.querySelectorAll('.wishlist-badge').forEach(function(badge) {
      if (count > 0) {
        badge.textContent = count;
        badge.style.display = 'flex';
      } else {
        badge.style.display = 'none';
      }
    });
  }

  // ========== CART — Shopify AJAX API ==========
  function addToCart(variantId, qty) {
    qty = qty || 1;
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: qty }] })
    })
    .then(function(r) {
      if (!r.ok) throw new Error('Cart add failed');
      return r.json();
    })
    .then(function() { return refreshCart(); })
    .then(function() { openCartDrawer(); })
    .catch(function(err) { console.error('Error adding to cart:', err); });
  }

  function updateCartItem(key, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
    .then(function(r) {
      if (!r.ok) throw new Error('Cart update failed');
      return r.json();
    })
    .then(function() { return refreshCart(); })
    .catch(function(err) { console.error('Error updating cart:', err); });
  }

  function removeCartItem(key) {
    return updateCartItem(key, 0);
  }

  function refreshCart() {
    return fetch('/cart.js', { headers: { 'Content-Type': 'application/json' } })
    .then(function(r) { return r.json(); })
    .then(function(cart) {
      renderCartItems(cart);
      updateCartBadge(cart.item_count);
      updateShippingBar(cart);
    });
  }

  function renderCartItems(cart) {
    var container = document.querySelector('[data-cart-items]');
    var subtotalEl = document.querySelector('[data-cart-subtotal]');
    var headerH3 = document.querySelector('.cart-drawer__header h3');
    if (!container) return;

    if (headerH3) headerH3.textContent = 'Tu carrito (' + cart.item_count + ')';

    if (cart.item_count === 0) {
      container.innerHTML =
        '<div class="cart-drawer__empty">' +
          '<svg viewBox="0 0 24 24"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4zM3 6h18M16 10a4 4 0 01-8 0"/></svg>' +
          '<p>Tu carrito está vacío</p>' +
        '</div>';
      if (subtotalEl) subtotalEl.textContent = formatMoney(0);
      return;
    }

    var html = '';
    cart.items.forEach(function(item) {
      var imgUrl = item.featured_image ? item.featured_image.url : (item.image || '');
      html +=
        '<div class="cart-item">' +
          '<div class="cart-item__image">' +
            '<img src="' + imgUrl + '" alt="' + escapeHtml(item.product_title) + '" loading="lazy">' +
          '</div>' +
          '<div class="cart-item__details">' +
            '<div class="cart-item__title">' + escapeHtml(item.product_title) + '</div>' +
            (item.variant_title && item.variant_title !== 'Default Title'
              ? '<div class="cart-item__variant">' + escapeHtml(item.variant_title) + '</div>' : '') +
            '<div class="cart-item__quantity">' +
              '<button class="cart-item__quantity-btn" data-qty-change data-key="' + item.key + '" data-delta="-1">−</button>' +
              '<span class="cart-item__quantity-value">' + item.quantity + '</span>' +
              '<button class="cart-item__quantity-btn" data-qty-change data-key="' + item.key + '" data-delta="1">+</button>' +
            '</div>' +
            '<div class="cart-item__price">' + formatMoney(item.final_line_price) + '</div>' +
          '</div>' +
          '<button class="cart-item__remove" data-remove-item="' + item.key + '" aria-label="Eliminar">&times;</button>' +
        '</div>';
    });
    container.innerHTML = html;
    if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);
    bindCartItemEvents();
  }

  function bindCartItemEvents() {
    document.querySelectorAll('[data-qty-change]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var key = btn.getAttribute('data-key');
        var delta = parseInt(btn.getAttribute('data-delta'));
        var valEl = btn.parentElement.querySelector('.cart-item__quantity-value');
        var currentQty = parseInt(valEl.textContent);
        var newQty = Math.max(0, currentQty + delta);
        updateCartItem(key, newQty);
      });
    });
    document.querySelectorAll('[data-remove-item]').forEach(function(btn) {
      btn.addEventListener('click', function() {
        removeCartItem(btn.getAttribute('data-remove-item'));
      });
    });
  }

  function updateShippingBar(cart) {
    var bar = document.querySelector('[data-shipping-bar]');
    if (!bar) return;
    var threshold = parseInt(bar.getAttribute('data-threshold') || '0') * 100;
    if (threshold <= 0) return;
    var remaining = threshold - cart.total_price;
    var msgEl = bar.querySelector('[data-shipping-message]');
    var fillEl = bar.querySelector('[data-shipping-fill]');
    if (msgEl) {
      msgEl.textContent = remaining > 0
        ? 'Te faltan ' + formatMoney(remaining) + ' para envío gratis'
        : '¡Tienes envío gratis!';
    }
    if (fillEl) {
      fillEl.style.width = Math.min(100, (cart.total_price / threshold) * 100) + '%';
    }
  }

  // ========== CART DRAWER OPEN/CLOSE ==========
  function openCartDrawer() {
    var overlay = document.querySelector('.cart-drawer__overlay');
    var drawer = document.querySelector('[data-cart-drawer]');
    if (overlay) overlay.classList.add('open');
    if (drawer) drawer.classList.add('open');
    document.body.style.overflow = 'hidden';
  }

  function closeCartDrawer() {
    var overlay = document.querySelector('.cart-drawer__overlay');
    var drawer = document.querySelector('[data-cart-drawer]');
    if (overlay) overlay.classList.remove('open');
    if (drawer) drawer.classList.remove('open');
    document.body.style.overflow = '';
  }

  // ========== WISHLIST DROPDOWN ==========
  function createWishlistDropdown(anchor) {
    var existing = document.getElementById('wishlist-dropdown');
    if (existing) return existing;
    var dd = document.createElement('div');
    dd.id = 'wishlist-dropdown';
    dd.innerHTML =
      '<div class="wl-dropdown-header">Favoritos</div>' +
      '<div class="wl-dropdown-body" id="wl-dropdown-body"></div>';
    anchor.style.position = 'relative';
    anchor.appendChild(dd);
    document.addEventListener('click', function(e) {
      if (!anchor.contains(e.target)) closeWishlistDropdown();
    });
    return dd;
  }

  function toggleWishlistDropdown(anchor) {
    var dd = createWishlistDropdown(anchor);
    if (dd.classList.contains('open')) {
      closeWishlistDropdown();
    } else {
      renderWishlistDropdown();
      dd.classList.add('open');
    }
  }

  function closeWishlistDropdown() {
    var dd = document.getElementById('wishlist-dropdown');
    if (dd) dd.classList.remove('open');
  }

  function renderWishlistDropdown() {
    var body = document.getElementById('wl-dropdown-body');
    if (!body) return;
    var list = getWishlist();
    if (list.length === 0) {
      body.innerHTML = '<div class="wl-dropdown-empty">Sin favoritos aún</div>';
      return;
    }
    var data = getWishlistData();
    var html = '';
    list.forEach(function(handle) {
      var p = data[handle];
      if (!p) return;
      html +=
        '<div class="wl-dropdown-item">' +
          '<a href="' + p.url + '" class="wl-dropdown-img"><img src="' + p.image + '" alt="' + escapeHtml(p.title) + '"></a>' +
          '<div class="wl-dropdown-info">' +
            '<a href="' + p.url + '" class="wl-dropdown-name">' + escapeHtml(p.title) + '</a>' +
            '<div class="wl-dropdown-price">' + formatMoney(p.price) + '</div>' +
          '</div>' +
          '<div class="wl-dropdown-actions">' +
            '<button class="wl-dropdown-cart" data-wl-add-handle="' + handle + '" data-wl-variant="' + (p.variantId || '') + '" aria-label="Añadir al carrito">' +
              '<svg viewBox="0 0 24 24"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4zM3 6h18M16 10a4 4 0 01-8 0"/></svg>' +
            '</button>' +
            '<button class="wl-dropdown-remove" data-wl-remove="' + handle + '" aria-label="Quitar de favoritos">&times;</button>' +
          '</div>' +
        '</div>';
    });
    body.innerHTML = html;

    body.querySelectorAll('[data-wl-add-handle]').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.stopPropagation();
        var vid = btn.getAttribute('data-wl-variant');
        if (vid) {
          addToCart(vid, 1);
          closeWishlistDropdown();
        }
      });
    });
    body.querySelectorAll('[data-wl-remove]').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.stopPropagation();
        removeFromWishlist(btn.getAttribute('data-wl-remove'));
        renderWishlistDropdown();
        updateHeartButtons();
      });
    });
  }

  function updateHeartButtons() {
    document.querySelectorAll('.wishlist-heart-btn[data-wishlist-handle]').forEach(function(btn) {
      btn.classList.toggle('active', isInWishlist(btn.getAttribute('data-wishlist-handle')));
    });
  }

  // ========== QUICK VIEW MODAL ==========
  function createQuickView() {
    if (document.getElementById('quickview-overlay')) return;
    var overlay = document.createElement('div');
    overlay.id = 'quickview-overlay';
    overlay.addEventListener('click', function(e) {
      if (e.target === overlay) closeQuickView();
    });
    var modal = document.createElement('div');
    modal.id = 'quickview-modal';
    modal.innerHTML =
      '<button class="qv-close" aria-label="Cerrar">&times;</button>' +
      '<div class="qv-body">' +
        '<div class="qv-gallery">' +
          '<img class="qv-img" id="qv-img" src="" alt="">' +
          '<div class="qv-thumbs" id="qv-thumbs"></div>' +
        '</div>' +
        '<div class="qv-info">' +
          '<span class="qv-tag" id="qv-tag"></span>' +
          '<h2 class="qv-name" id="qv-name"></h2>' +
          '<p class="qv-price" id="qv-price"></p>' +
          '<p class="qv-desc" id="qv-desc"></p>' +
          '<div class="qv-variants" id="qv-variants"></div>' +
          '<div class="qv-actions">' +
            '<div class="qv-qty">' +
              '<button class="qv-qty-btn" id="qv-minus">−</button>' +
              '<span class="qv-qty-val" id="qv-qty-val">1</span>' +
              '<button class="qv-qty-btn" id="qv-plus">+</button>' +
            '</div>' +
            '<button class="qv-add-cart" id="qv-add-cart">Añadir al carrito</button>' +
          '</div>' +
          '<a class="qv-detail-link" id="qv-detail-link" href="#">Ver todos los detalles →</a>' +
        '</div>' +
      '</div>';
    overlay.appendChild(modal);
    document.body.appendChild(overlay);
    modal.querySelector('.qv-close').addEventListener('click', closeQuickView);
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') closeQuickView();
    });
  }

  var _qvQty = 1;
  var _qvVariantId = null;

  function openQuickView(handle) {
    createQuickView();
    fetch('/products/' + handle + '.js')
    .then(function(r) { return r.json(); })
    .then(function(product) {
      _qvQty = 1;
      _qvVariantId = product.variants[0].id;

      var mainImg = product.featured_image || (product.images.length ? product.images[0] : '');
      document.getElementById('qv-img').src = mainImg;
      document.getElementById('qv-img').alt = product.title;

      var thumbsHtml = '';
      product.images.forEach(function(img, i) {
        thumbsHtml += '<img class="qv-thumb' + (i === 0 ? ' active' : '') + '" src="' + img + '" alt="' + escapeHtml(product.title) + '">';
      });
      document.getElementById('qv-thumbs').innerHTML = thumbsHtml;
      document.querySelectorAll('.qv-thumb').forEach(function(th) {
        th.addEventListener('click', function() {
          document.getElementById('qv-img').src = th.src;
          document.querySelectorAll('.qv-thumb').forEach(function(t) { t.classList.remove('active'); });
          th.classList.add('active');
        });
      });

      document.getElementById('qv-tag').textContent = product.type || '';
      document.getElementById('qv-name').textContent = product.title;
      document.getElementById('qv-price').textContent = formatMoney(product.variants[0].price);

      var desc = product.description ? product.description.replace(/<[^>]*>/g, '') : '';
      if (desc.length > 200) desc = desc.substring(0, 200) + '...';
      document.getElementById('qv-desc').textContent = desc;

      document.getElementById('qv-qty-val').textContent = '1';
      document.getElementById('qv-detail-link').href = '/products/' + handle;

      var variantsContainer = document.getElementById('qv-variants');
      if (product.variants.length > 1) {
        var vHtml = '<select class="qv-variant-select" id="qv-variant-select">';
        product.variants.forEach(function(v) {
          vHtml += '<option value="' + v.id + '" data-price="' + v.price + '"' +
            (!v.available ? ' disabled' : '') + '>' +
            escapeHtml(v.title) + (v.available ? '' : ' — Agotado') +
            '</option>';
        });
        vHtml += '</select>';
        variantsContainer.innerHTML = vHtml;
        document.getElementById('qv-variant-select').addEventListener('change', function() {
          _qvVariantId = parseInt(this.value);
          var price = parseInt(this.selectedOptions[0].getAttribute('data-price'));
          document.getElementById('qv-price').textContent = formatMoney(price);
        });
      } else {
        variantsContainer.innerHTML = '';
      }

      document.getElementById('qv-minus').onclick = function() {
        if (_qvQty > 1) { _qvQty--; document.getElementById('qv-qty-val').textContent = _qvQty; }
      };
      document.getElementById('qv-plus').onclick = function() {
        _qvQty++; document.getElementById('qv-qty-val').textContent = _qvQty;
      };
      document.getElementById('qv-add-cart').onclick = function() {
        if (_qvVariantId) {
          addToCart(_qvVariantId, _qvQty);
          closeQuickView();
        }
      };

      document.getElementById('quickview-overlay').classList.add('open');
      document.body.style.overflow = 'hidden';
    })
    .catch(function(err) {
      console.error('Error loading product:', err);
    });
  }

  function closeQuickView() {
    var overlay = document.getElementById('quickview-overlay');
    if (overlay) {
      overlay.classList.remove('open');
      document.body.style.overflow = '';
    }
  }

  // ========== SEARCH (Shopify Predictive Search) ==========
  function createSearchOverlay() {
    if (document.getElementById('search-overlay')) return;
    var overlay = document.createElement('div');
    overlay.id = 'search-overlay';
    overlay.innerHTML =
      '<div class="search-modal">' +
        '<div class="search-modal-header">' +
          '<div class="search-input-wrap">' +
            '<svg class="search-input-icon" viewBox="0 0 24 24"><circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/></svg>' +
            '<input type="text" id="search-input" placeholder="Buscar productos..." autocomplete="off">' +
          '</div>' +
          '<button class="search-close" aria-label="Cerrar">&times;</button>' +
        '</div>' +
        '<div class="search-results" id="search-results"></div>' +
      '</div>';
    document.body.appendChild(overlay);
    overlay.addEventListener('click', function(e) {
      if (e.target === overlay) closeSearch();
    });
    var input = document.getElementById('search-input');
    var debounceTimer;
    input.addEventListener('input', function() {
      clearTimeout(debounceTimer);
      var q = input.value.trim();
      debounceTimer = setTimeout(function() { runSearch(q); }, 300);
    });
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') closeSearch();
    });
  }

  function openSearch() {
    createSearchOverlay();
    document.getElementById('search-overlay').classList.add('open');
    document.body.style.overflow = 'hidden';
    setTimeout(function() { document.getElementById('search-input').focus(); }, 100);
    document.getElementById('search-results').innerHTML = '';
  }

  function closeSearch() {
    var overlay = document.getElementById('search-overlay');
    if (overlay) {
      overlay.classList.remove('open');
      document.body.style.overflow = '';
    }
  }

  function runSearch(query) {
    var results = document.getElementById('search-results');
    if (!results) return;
    if (!query) { results.innerHTML = ''; return; }

    fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=6')
    .then(function(r) { return r.json(); })
    .then(function(data) {
      var products = data.resources.results.products || [];
      if (products.length === 0) {
        results.innerHTML = '<div class="search-empty">No se encontraron resultados</div>';
        return;
      }
      var html = '';
      products.forEach(function(p) {
        html +=
          '<a href="' + p.url + '" class="search-result-item">' +
            '<div class="search-result-img"><img src="' + (p.image || '') + '" alt="' + escapeHtml(p.title) + '"></div>' +
            '<div class="search-result-info">' +
              '<span class="search-result-name">' + escapeHtml(p.title) + '</span>' +
              '<span class="search-result-meta">' + formatMoney(Math.round(parseFloat(p.price) * 100)) + '</span>' +
            '</div>' +
          '</a>';
      });
      results.innerHTML = html;
    })
    .catch(function() {
      results.innerHTML = '<div class="search-empty">Error al buscar</div>';
    });
  }

  // ========== INIT ==========
  function init() {
    var cartOverlay = document.querySelector('.cart-drawer__overlay');
    var cartClose = document.querySelector('[data-cart-close]');
    if (cartOverlay) cartOverlay.addEventListener('click', closeCartDrawer);
    if (cartClose) cartClose.addEventListener('click', closeCartDrawer);
    bindCartItemEvents();

    document.querySelectorAll('.nav-icons a[aria-label="Wishlist"]').forEach(function(a) {
      a.setAttribute('href', '#');
      a.addEventListener('click', function(e) {
        e.preventDefault();
        toggleWishlistDropdown(a);
      });
      if (!a.querySelector('.wishlist-badge')) {
        var badge = document.createElement('span');
        badge.className = 'wishlist-badge';
        badge.style.display = 'none';
        a.style.position = 'relative';
        a.appendChild(badge);
      }
    });

    document.querySelectorAll('.nav-icons a[aria-label="Carrito"]').forEach(function(a) {
      a.setAttribute('href', '#');
      a.addEventListener('click', function(e) {
        e.preventDefault();
        openCartDrawer();
      });
      if (!a.querySelector('.cart-badge')) {
        var badge = document.createElement('span');
        badge.className = 'cart-badge';
        badge.style.display = 'none';
        a.style.position = 'relative';
        a.appendChild(badge);
      }
    });

    var navIcons = document.querySelector('.nav-icons');
    if (navIcons && !navIcons.querySelector('[aria-label="Buscar"]')) {
      var searchLink = document.createElement('a');
      searchLink.setAttribute('href', '#');
      searchLink.setAttribute('aria-label', 'Buscar');
      searchLink.innerHTML = '<svg viewBox="0 0 24 24"><circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/></svg>';
      searchLink.addEventListener('click', function(e) {
        e.preventDefault();
        openSearch();
      });
      navIcons.insertBefore(searchLink, navIcons.firstChild);
    }

    document.querySelectorAll('.wishlist-heart-btn[data-wishlist-handle]').forEach(function(btn) {
      var handle = btn.getAttribute('data-wishlist-handle');
      btn.classList.toggle('active', isInWishlist(handle));
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        var card = btn.closest('[data-product-handle]');
        var info = null;
        if (card) {
          var titleEl = card.querySelector('.product-card__title a');
          var mediaEl = card.querySelector('.product-card__media');
          var imgEl = card.querySelector('.product-card__media img');
          info = {
            title: titleEl ? titleEl.textContent.trim() : '',
            price: parseInt(card.getAttribute('data-product-price')) || 0,
            image: imgEl ? imgEl.src : '',
            url: mediaEl ? mediaEl.getAttribute('href') : '/products/' + handle,
            variantId: card.getAttribute('data-variant-id') || ''
          };
        }
        var added = toggleWishlist(handle, info);
        btn.classList.toggle('active', added);
      });
    });

    document.addEventListener('submit', function(e) {
      var form = e.target.closest('[data-add-to-cart-form]');
      if (!form) return;
      e.preventDefault();
      var idInput = form.querySelector('[name="id"]');
      var qtyInput = form.querySelector('[name="quantity"]');
      if (idInput) {
        addToCart(idInput.value, qtyInput ? parseInt(qtyInput.value) : 1);
      }
    });

    document.querySelectorAll('[data-quick-view]').forEach(function(btn) {
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        e.stopPropagation();
        openQuickView(btn.getAttribute('data-quick-view'));
      });
    });

    var initialCount = (window.Cellmula && window.Cellmula.cartCount) || 0;
    updateCartBadge(initialCount);
    updateWishlistBadge();
  }

  document.addEventListener('DOMContentLoaded', init);

  window.addToCart = addToCart;
  window.openCartDrawer = openCartDrawer;
  window.closeCartDrawer = closeCartDrawer;
  window.openQuickView = openQuickView;
  window.closeQuickView = closeQuickView;
})();
